module.exports = __webpack_public_path__ + "img/29.2dafc9dd.jpg";